
/* eslint-disable array-callback-return */
import _ from 'lodash'
import PropTypes from 'prop-types'

import './Comment.styles.scss'
import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'

export const Comment = ({
  text,
  author,
  parent,
  time,
  labelColor = 'blue'
}) => (
  <div className='igao-comment'>
    <div
      className={`title ${labelColor}`}
      title={parent.title}
    >
      {parent.label}
    </div>
    <p>{text}</p>
    <span className='author'>{author}</span>
    <div>
      <FriendlyDateTime
        short
        datetime={time}
      />
    </div>
  </div>
)

Comment.propsType = {
  text: PropTypes.string,
  author: PropTypes.string,
  parent: PropTypes.shape({
    label: PropTypes.string,
    title: PropTypes.string
  })
}

const mapToComponent = (
  { authorReference, text, time },
  description,
  label,
  labelColor
) => ({
  parent: {
    title: description,
    label
  },
  author: authorReference?.display || 'Compassion System',
  text,
  time,
  labelColor
})

export const pullCommentsFromIssue = issue => {
  const comments = issue.comments.length
    ? issue.comments.map(c =>
      mapToComponent(c, issue.description, 'I', 'blue'))
    : []
  issue.actions
    .filter(a => {
      if (a.comments && a.comments.length) {
        return a
      }
    })
    .map(a =>
      a.comments.map(c => mapToComponent(c, a.description, 'A', 'red')))
    .forEach(actionComments =>
      actionComments.forEach(c => comments.push(c)))
  return _.orderBy(comments, [ 'time' ], [ 'desc' ])
}
